import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Input from '@prism/input';
import { FormGroup } from '@prism/form';
import _ from 'lodash';

class InputInteractive extends React.PureComponent {
    state = {
        isShowEye: false,
        pasted: false,
        valuePasted: ''
	};

    componentDidMount() {
        if (_.isEmpty(this.props.value) && this.props.type === 'password') {
            this.setState({ isShowEye: true });
        }
    }

    onHandlePasteValue = (isPaste, event) => {
        if (!isPaste) {
            event.preventDefault();
        }
        
        if (isPaste && this.props.isSecurityQuestion) {
            const value = (event.clipboardData || window.clipboardData).getData('Text');
            this.setState({ pasted: true, valuePasted: value });
        }
    };

    onHandleChange = e => {
        this.props.onChange(e);
        const value = e.target.value;
        const { pasted, valuePasted } = this.state;

        if (_.isEmpty(value) && this.props.type === 'password') {
            this.setState({ isShowEye: true });
            return;
        }

        const valueReplaced = (value.length === 1 && value !== '*') || (pasted && valuePasted === value);
        if (valueReplaced && this.props.isSecurityQuestion) {
            this.setState({ isShowEye: true });
        }
    }

    renderLabel = ({
        id,
        label,
        required
    }) => typeof label === 'string'
        ? (
            <label htmlFor={id} className='control-label'>
                {label}
                {required && <span className="required-symbol">*</span>}
            </label>
        )
        : label;

    renderInput = ({ valid, invalid, disabled, isPaste, ...props }) => {

        return (
            <Input.Interactive
                {...props}
                disabled={disabled}
                invalid={invalid && !disabled}
                onPaste={(event) => this.onHandlePasteValue(isPaste, event)}
                onChange={this.onHandleChange}
            />
        )
    };

    renderHelp = ({ help }) => typeof help === 'string'
        ? (
            <span className='prism-input-interactive__help'>
                {help}
            </span>
        )
        : help;

    renderErrors = ({ errors, invalid }) => {
        return (
            <div>
                {errors.map((e, index) => (
                    <div key={e + index}>
                        <span className="help-block validation-message">{e}</span>
                    </div>
                ))}
            </div>
        );
    };

    render() {
        const {
            className,
            inputClassName,
            label,
            help,
            errors,
            isSecurityQuestion,
            isFocus,
            prismStyle,
            ...inputProps
        } = this.props;

        const containerClassName = classNames(
            {'prism-sandbox': prismStyle},
            {'prism-input': prismStyle},
            'prism-input-interactive',
            { 'prism-input__hide-icon-right': !this.state.isShowEye && isSecurityQuestion },
            className
        );

        const elementClassName = classNames(
            'prism-input-interactive__control',
            {'prism-input__control': prismStyle},
            {'focus': isFocus},
            inputClassName
        );

        return (
            <div className={containerClassName}>
                <FormGroup className={!_.isEmpty(errors) ? 'has-error has-feedback' : ''}>
                    {label && this.renderLabel(this.props)}
                    {this.renderInput({ ...inputProps, className: elementClassName })}
                    {help && this.renderHelp(this.props)}
                    {errors && this.renderErrors(this.props)}
                </FormGroup>
            </div>
        );
    }
}

InputInteractive.propTypes = {
    innerRef: PropTypes.object,
    id: PropTypes.string,
    className: PropTypes.string,
    inputClassName: PropTypes.string,
    name: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    help: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    placeholder: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.any,
    autofocus: PropTypes.bool,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    valid: PropTypes.bool,
    invalid: PropTypes.bool,
    errors: PropTypes.arrayOf(PropTypes.string),
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    isPaste: PropTypes.bool,
    isFocus: PropTypes.bool,
    prismStyle: PropTypes.bool
};

InputInteractive.defaultProps = {
    type: 'text',
    value: '',
    isPaste: true,
    errors: [],
    onBlur: () => { },
    isSecurityQuestion: false
};

export default InputInteractive;
